import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { Lock, CheckCircle2 } from "lucide-react";
import AuthLayout from "../components/AuthLayout";
import { api, errMsg } from "../lib/api";

export default function Reset() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [err, setErr] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (password !== confirm) {
      setErr("Passwords do not match");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
      setTimeout(() => nav("/login"), 1800);
    } catch (e2) {
      setErr(errMsg(e2));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout>
      <h2 className="text-2xl font-extrabold mb-1" data-testid="reset-title">
        Set a new password
      </h2>
      <p className="text-tv-sub text-sm mb-7">Choose a strong password for your account.</p>

      {!token && (
        <div className="mb-4 text-sm text-tv-orange bg-tv-orange/10 border border-tv-orange/30 rounded-xl px-4 py-3">
          Missing reset token. Please use the link from your reset request.
        </div>
      )}
      {err && <div className="mb-4 text-sm text-tv-red bg-tv-red/10 border border-tv-red/30 rounded-xl px-4 py-3" data-testid="reset-error">{err}</div>}

      {done ? (
        <div className="card p-5 flex items-center gap-3 text-tv-green" data-testid="reset-success">
          <CheckCircle2 size={22} />
          <span className="text-sm text-tv-text">Password updated! Redirecting to sign in…</span>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="text-xs font-semibold text-tv-sub mb-1.5 block">New password</label>
            <div className="relative">
              <Lock size={16} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-tv-muted" />
              <input type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="At least 6 characters" className="field pl-10" data-testid="reset-password-input" />
            </div>
          </div>
          <div>
            <label className="text-xs font-semibold text-tv-sub mb-1.5 block">Confirm password</label>
            <div className="relative">
              <Lock size={16} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-tv-muted" />
              <input type="password" required minLength={6} value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder="Repeat password" className="field pl-10" data-testid="reset-confirm-input" />
            </div>
          </div>
          <button type="submit" disabled={loading || !token} className="btn-primary w-full flex items-center justify-center gap-2" data-testid="reset-submit-button">
            {loading ? <span className="spinner" /> : null}
            {loading ? "Updating…" : "Update password"}
          </button>
        </form>
      )}

      <p className="text-center text-sm text-tv-sub mt-6">
        <Link to="/login" className="text-tv-cyan font-semibold hover:underline">Back to sign in</Link>
      </p>
    </AuthLayout>
  );
}
